/** @module Specification/LanguageMatrix */
define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/store/Nodes",
	"csi/table/matrix/ColumnMap",
	"csi/xml/Query"
], function(declare, _, Nodes, ColumnMap, Query) {

	return declare(ColumnMap, {
		hideLoneSubheader: true,

		/** @property {Nodes} _languageStore - Data store of the site-level Language nodes */
		_languageStore: null,

		/**
		 * Query for all languages
		 */
		addDeferred: function(ctx, h, dfds) {
			this._languageStore = new Nodes({
				cachingStore: ctx.cache,
				sortQuery: new Query().SortByAttr("SortOrder"),
				typeNode: "Language"
			});

			dfds.push(this._languageStore.query());
		},

		/**
		 * If view has active languages, then only return subset of all languages
		 */
		_getColumnNodes: function(ctx, h) {
			var activeLanguages = ctx.view.activeLanguages;
			var languages = this._languageStore.query();

			if (activeLanguages) {
				languages = _.filter(languages, function(node) {
					return activeLanguages.indexOf(node.$URL) > -1;
				});
			}

			return languages;
		}
	});
});
